import React, { useState } from 'react'

import { remove } from '../BillingTypeActions'
import { useDispatch, useSelector } from 'react-redux'
import {
  Box,
  IconButton,
  makeStyles,
  Table,
  TableBody,
  TableContainer,
  TableHead,
  TableRow,
} from '@material-ui/core'
import {
  StyledTableCellBody,
  StyledTableCellHeader,
} from '../../../components/hooks/BaseTableComponents'
import Pagination from '../../../components/hooks/BasePagination'
import EnhancedTableHead from '../../components/TableHead'
import colors from '../../../assets/colors'
import { useQueryParams } from '../../../util/utils'
import { usePermissions } from '../../../hooks/usePermission'
import { getSorting, stableSort } from '../../../util/TableUtils'
import { mdiDelete, mdiNoteEditOutline } from '@mdi/js'
import Icon from '@mdi/react'
import {
  Link,
  useHistory,
  useLocation,
} from 'react-router-dom/cjs/react-router-dom.min'
import BasePopUp from '../../../components/hooks/BasePopUp'

const useStyles = makeStyles({
  status: {
    textAlign: 'center',
    fontSize: '14px',
    borderRadius: '10px',
    padding: '4px 16px',
    maxWidth: '80px',
    backgroundColor: colors.graylight,
    color: '#000',
  },
  statusAtivo: {
    color: '#FFFF',
    backgroundColor: colors.secondary,
  },
})

const headCells = [
  {
    id: 'id',
    numeric: false,
    disablePadding: true,
    label: 'ID',
  },
  {
    id: 'name',
    numeric: true,
    disablePadding: false,
    label: 'Nome',
  },
  {
    id: 'type',
    numeric: true,
    disablePadding: false,
    label: 'Tipo',
  },
  {
    id: 'status',
    numeric: true,
    disablePadding: false,
    label: 'Status',
  },
  {
    id: 'actions',
    numeric: true,
    disablePadding: false,
    label: 'Ações',
    align: 'center',
  },
]

const List = ({ classes }) => {
  const items = useSelector(state => state.billingType.items)
  const meta = useSelector(state => state.billingType.meta)
  const permissionUser = useSelector(state => state.auth.permissionUser)
  const { canUpdate, canDelete } = usePermissions()

  const location = useLocation()
  const history = useHistory()
  const dispatch = useDispatch()

  const filters = useQueryParams(location.search)

  const [order, setOrder] = useState('asc')
  const [orderBy, setOrderBy] = useState('name')

  const styles = useStyles()

  const [openDeleteModal, setOpenDeleteModal] = useState(false)
  const [billingTypeToDelete, setBillingTypeToDelete] = useState(null)

  const handleChangeRowsPerPage = event => {
    const data = { ...filters, rows: event.target.value, page: 1 }
    handleSubmit(data)
  }

  const handleSubmit = data => {
    const searchParams = new URLSearchParams(data || filters)
    history.push(`${location?.pathname}?${searchParams?.toString()}`)
  }

  const onMovePage = (event, newPage) => {
    const data = { ...filters, page: newPage }
    handleSubmit(data)
  }

  const handleRequestSort = (event, property) => {
    const isDesc = orderBy === property && order === 'desc'
    setOrder(isDesc ? 'asc' : 'desc')
    setOrderBy(property)
  }

  const handleOpenDeleteModal = (id = null) => {
    if (id) {
      setBillingTypeToDelete(id)
    }
    setOpenDeleteModal(!openDeleteModal)
  }

  const handleConfirmDelete = async () => {
    if (!billingTypeToDelete) return

    const ok = await dispatch(remove(billingTypeToDelete))
    if (!ok) return

    handleSubmit(filters)
    setOpenDeleteModal(false)
    setBillingTypeToDelete(null)
  }

  return (
    <>
      <TableContainer className={classes.tableStickHeader}>
        <Table size="small" className={classes.table}>
          <EnhancedTableHead
            classes={classes}
            order={order}
            orderBy={orderBy}
            onRequestSort={handleRequestSort}
            rowCount={items.length}
            headCells={headCells}
            hideID
          />
          <TableBody>
            {stableSort(items, getSorting(order, orderBy)).map(row => (
              <TableRow hover tabIndex={-1} key={row.id}>
                <StyledTableCellHeader padding="checkbox" />
                <StyledTableCellBody>{row?.name}</StyledTableCellBody>
                <StyledTableCellBody>{row?.type_text}</StyledTableCellBody>

                <StyledTableCellBody>
                  {row.status_text.toLowerCase() === 'ativo' ? (
                    <Box className={[styles.status, styles.statusAtivo]}>
                      {row.status_text}
                    </Box>
                  ) : (
                    <Box className={styles.status}>{row.status_text}</Box>
                  )}
                </StyledTableCellBody>

                <StyledTableCellBody align="center">
                  {canUpdate('centro-custo', permissionUser) &&
                    row?.is_client_service != 1 && (
                      <IconButton
                        aria-label="edit"
                        component={Link}
                        to={`/billing-type/${row.id}/edit${location.search}`}
                      >
                        <Icon path={mdiNoteEditOutline} size={1} />
                      </IconButton>
                    )}
                  {canDelete('centro-custo', permissionUser) &&
                    row.is_client_service != 1 && (
                      <IconButton onClick={() => handleOpenDeleteModal(row.id)}>
                        <Icon path={mdiDelete} size={1} />
                      </IconButton>
                    )}
                </StyledTableCellBody>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>

      <Pagination
        from={meta?.from}
        to={meta?.to}
        handleChangeRowsPerPage={handleChangeRowsPerPage}
        rowsPerPage={meta?.per_page}
        rows={meta?.total}
        page={meta?.current_page}
        handleChangePage={onMovePage}
      />

      <BasePopUp
        open={openDeleteModal}
        type="error"
        title="Excluir Tipo de Cobrança"
        message="Deseja realmente excluir este tipo de cobrança?"
        handleOpen={handleOpenDeleteModal}
        onConfirm={handleConfirmDelete}
      />
    </>
  )
}

export default List
